<div class="main">

  <div class="section">
    <div class="download-btn">
      <div style="margin:5px;float: left;">
        <a [href]="invoice_data.invoice_link" download >
          <img src="assets/download_link.svg" alt="" width="30" height="20" style="cursor: pointer;">
        </a>

      </div>
      <div style="float: right;">
        <mat-icon style="cursor: pointer;" (click)="backClicked()">keyboard_backspace</mat-icon>
      </div>
    </div>
    <div class="body">
      <!--  *ngIf="freightInvoice.is_verified" -->
      <p class="approvedWaterMark">
        {{ invoice_data.status }} </p>
      <!-- <p class="notApprovedWaterMark">
        'Not Approved' </p> *ngIf="!freightInvoice.is_verified" -->
      <table class="topSection" cellspacing="0" cellpadding="0" border="1">
        <tbody>
          <tr>
            <td>
              <div class="companyAddress">
                <!-- Carrier Address / Name -->
                <table class="leftTable" cellspacing="0" cellpadding="0">
                  <tbody>
                    <tr>
                      <!-- Instavan Address -->
                      <td style="border: 0" class="companyDetails">
                        <p style="font-weight: bold"> {{ invoice_data.carrier_info.enterprise }} - {{ invoice_data.carrier_info.unit }} </p>
                        <!-- {shipment.carrier.parent_name} - ${shipment.carrier.name}-->
                        <p style="margin: 5px 0;">
                          {{ invoice_data.carrier_info.area }}
                          <!-- shipment.carrier.location.area -->
                        </p><span>{{'INVOICE_PREVIEW.ph' | translate}} : {{ invoice_data.carrier_info.mobile }} </span> <!-- shipment.carrier.location.mobile -->
                      </td>
                    </tr>
                    <tr>
                      <td class="gstDetails" colspan="2">
                        <table class="gstTable" cellspacing="0" cellpadding="0">
                          <tr>
                            <td class="borderPadding">{{'INVOICE_PREVIEW.gstno' | translate}}</td>
                            <td class="borderPadding">
                              {{ invoice_data.carrier_info.tax_number || 'N/A'}}
                              <!-- shipment.carrier.tax_number || 'N/A' -->
                            </td>
                          </tr>
                          <tr>
                            <td class="borderPadding">{{'INVOICE_PREVIEW.reverse_charge' | translate}}</td>
                            <td class="borderPadding">
                              {{ invoice_data.tax_type == 'RCM' ? 'Yes' : 'No'}}
                              <!-- shipment.carrier.tax_number || 'N/A' -->
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                    <!-- Shipper Address / Name -->
                    <tr>
                      <td class="shipperBuyer" colspan="2">
                        <div>{{'INVOICE_PREVIEW.shipper_buyer' | translate}}</div>
                        <div class="shipperPersonalInfo">
                          <div class="shipperName">
                            <span>
                              {{ invoice_data.bill_to_info.enterprise }} - {{ invoice_data.bill_to_info.unit }}
                            </span>
                            <!-- {shipment.shipper.parent_name} - ${shipment.shipper.name} -->
                          </div>
                          <div class="shipperAddress">
                            <span> {{ invoice_data.bill_to_info.area }} </span>
                            <!-- shipment.shipper.location.area -->
                            <!-- <p>{{'INVOICE_PREVIEW.ph' | translate}} : {{ invoice_data.bill_to_info.mobile }} </p> shipment.shipper.location.mobile -->
                          </div>
                          <div><strong>{{'INVOICE_PREVIEW.gstno' | translate}} : </strong>
                            <span>{{ invoice_data.bill_to_info.tax_number || 'N/A'}}</span> 

                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <!-- End: Company Address / Shippers Name -->
              </div>
            </td>
            <!--End: Instavans Address -->
            <!-- Other Details -->
            <td>
              <div class="logo-container">
                <img src="{{logo}}" alt="" height="80" width="120">
              </div>
              <h3 class="freightHeading">{{'INVOICE_PREVIEW.freight_invoice' | translate}}</h3>
              <div class="otherDetails">
                <!-- Other Details -->
                <table class="rightTable" cellspacing="0" cellpadding="0">
                  <tbody>
                    <!-- Billing Cycle -->
                    <tr>
                      <td>
                        <!-- {{(freightInvoice.is_verified) ? "Invoice No." : "Version No."}} -->
                        {{'INVOICE_PREVIEW.invoice_no' | translate}} :
                      </td>
                      <td>
                        {{ invoice_data.IINC }}
                        <!-- {{freightInvoice.unique_code}} -->
                      </td>
                    </tr>
                    <tr>
                      <td>{{'INVOICE_PREVIEW.invoice_date' | translate}} </td>
                      <td>
                        <!-- {{date}} -->
                        {{ invoice_data.created_at }}
                      </td>
                    </tr>
                    <tr>
                      <td>{{'INVOICE_PREVIEW.order_no' | translate}}
                        <!-- {{(freightInvoice.lr_unique_type) ? freightInvoice.lr_unique_type : '' }} -->
                      </td>
                      <td>
                        <!-- N6V0134 - 45321 -->
                        {{ invoice_data.SIN }}
                        <!-- {{shipment.SIN}} {{(freightInvoice.lr_unique_id) ? freightInvoice.lr_unique_id : ''}} -->
                      </td>
                    </tr>
                    <tr>
                      <td>{{'INVOICE_PREVIEW.order_date' | translate}}</td>
                      <td>
                        {{ timeService.toShortDate( invoice_data.shipment.created_at )}}
                        <!-- {{shipment.created_at.getDate() + '/' + (shipment.created_at.getMonth() + 1) + '/' + shipment.created_at.getFullYear()}} -->
                      </td>
                    </tr>
                    <tr>
                      <td>{{'INVOICE_PREVIEW.date_of_service' | translate}}</td>
                      <td>
                        {{ timeService.toShortDate( invoice_data.shipment.accepted_at )}}
                        <!-- {{shipment.started_at.getDate() + '/' + (shipment.started_at.getMonth() + 1) + '/' + shipment.started_at.getFullYear()}} -->
                      </td>
                    </tr>
                    <tr>
                      <td>{{'INVOICE_PREVIEW.vehicle_type' | translate}}</td>
                      <td>
                        {{ invoice_data.vehicle_name }} / {{ invoice_data.vehicle_no }}
                        <!-- {{shipment.vehicle_type.name}} /
                        {{shipment.driver.vehicle_no}} -->
                      </td>
                    </tr>
                    <tr>
                      <td>{{'INVOICE_PREVIEW.desc' | translate}}</td>
                      <td>{{'INVOICE_PREVIEW.trans_text' | translate}}</td>
                    </tr>
                    <tr>
                      <td>{{'INVOICE_PREVIEW.sac' | translate}}</td>
                      <td>
                        {{ invoice_data.sac_code || 'N/A' }}
                      </td>
                    </tr>
                    <tr>
                      <td>{{'INVOICE_PREVIEW.purchase_order' | translate}}</td>
                      <td>
                        {{ invoice_data.purchase_order || 'N/A' }}
                      </td>
                    </tr>
                    <tr>
                      <td>{{'INVOICE_PREVIEW.ref_number' | translate}}</td>
                      <td>
                        {{ invoice_data.ref_number || 'N/A' }}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <!-- End: Other Details -->
              </div>
            </td>
            <!-- End: Other Details -->
          </tr>
        </tbody>
      </table>
      <!-- shipper Info Table -->
      <div class="shipperInfoTable">
        <table class="locationTable" border="1" cellspacing="0" cellpadding="0">
          <!-- table Heading -->
          <thead>
            <tr>
              <th class="fromTo">{{'INVOICE_PREVIEW.consignor_from' | translate}}</th>
              <th class="fromTo">{{'INVOICE_PREVIEW.consignor_to' | translate}}</th>
              <th>{{'INVOICE_PREVIEW.gross_weight' | translate}}({{invoice_data.measure_unit}})</th>
              <th>{{'INVOICE_PREVIEW.net_weight' | translate}}({{invoice_data.measure_unit}})</th>
              <th *ngIf="show_distance">{{'INVOICE_PREVIEW.km' | translate}}</th>
              <th *ngIf="show_weight">{{'INVOICE_PREVIEW.rate_per_weight' | translate}} ({{ currencySymbol }})</th>
              <th *ngIf="show_cbm || show_package">{{'INVOICE_PREVIEW.rate_per_package' | translate}} ({{ currencySymbol }})</th>
              <th>{{'INVOICE_PREVIEW.LR' | translate}}</th>
              <th class="freight">{{'INVOICE_PREVIEW.freight_charges' | translate}} ({{ currencySymbol }})</th>
            </tr>
          </thead>
          <!-- table Data -->
          <tbody>
            <tr>
              <td>
                <ul class="locsUL" *ngFor="let pickup of invoice_data.pickups">
                  <!-- for (var i = 0 ; i < shipment.pickups.length - 1 ; i++) { -->
                  <li class="locs">
                    <div class="bulletDiv">
                      <img src="https://s3.ap-south-1.amazonaws.com/instavans-pic/prod/iconBullets.png">
                    </div>
                    <div class="address">
                      <span>
                        <strong> {{ pickup.location.name }}
                          <!--item.location.name --> -
                        </strong>
                      </span>
                      {{ pickup.location.area }}
                      <!--item.location.area -->
                    </div>
                  </li>
                  <!-- } -->
                  <!-- <li style="border-left: 1px dashed #f00;text-align: left;margin-left:10px;">
                      <div style="float: left;height: 40px;position: relative;margin-left: -5px;">
                        <img src="https://s3.ap-south-1.amazonaws.com/instavans-pic/prod/iconBullets.png"></div>
                      <div style="padding-left: 15px;padding-bottom:10px;margin: 0;">
                        <span><strong> shipment.pickups[i].location.name -
                          </strong></span> shipment.pickups[i].location.area
                      </div>
                    </li> -->
                </ul>
              </td>
              <td>
                <ul class="locsUL" *ngFor="let delivery of invoice_data.deliveries">
                  <!-- for (var i = 0 ; i < shipment.deliveries.length - 1 ; i++) {  -->
                  <li class="locs">
                    <div class="bulletDiv">
                      <img src="https://s3.ap-south-1.amazonaws.com/instavans-pic/prod/iconBullets.png">
                    </div>
                    <div class="address">
                      <span>
                        <strong>
                          {{ delivery.location.name }} -
                          <!-- item.location.name -->
                        </strong>
                      </span>
                      {{ delivery.location.area }}
                      <!-- item.location.area -->
                    </div>
                  </li>
                  <!-- } -->
                  <!-- <li style="border-left: 1px dashed #f00;text-align: left;">
                      <div style="float: left;height: 40px;position: relative;margin-left: -5px;">
                        <img src="https://s3.ap-south-1.amazonaws.com/instavans-pic/prod/iconBullets.png"></div>
                      <div style="padding-left: 15px;padding-bottom:10px;margin: 0;">
                        <span><strong> shipment.deliveries[i].location.name -
                          </strong></span> shipment.deliveries[i].location.area
                      </div>
                    </li> -->
                </ul>
              </td>
              <td class="center">
                <!-- var totalPackages = 0;
                shipment.pickups.forEach((item) => totalPackages += parseInt(item.actual_pickup)) -->
                <!-- {{totalPackages}} -->
                {{ invoice_data.gross_weight || 'N/A'}}
              </td>
              <td class="center">
                <!-- var totalPackages = 0;
                shipment.pickups.forEach((item) => totalPackages += parseInt(item.actual_pickup)) -->
                <!-- {{totalPackages}} -->
                {{ invoice_data.net_weight || 'N/A'}}
              </td>
              <td class="center" *ngIf="show_distance">
                <!-- {{parseFloat(shipment.estimated.distance/1000).toFixed(2)}} -->
                {{this.distance}}
              </td>
              <td class="center" *ngIf="show_weight || show_cbm || show_package">
                <!-- {{parseFloat(shipment.estimated.distance/1000).toFixed(2)}} -->
                {{invoice_data.price_per_unit}}
              </td>
              <td class="center"> {{ invoice_data.waybill }} </td>
              <td class="center">
                <strong> {{invoice_data.initial_amount.value}} </strong>
                <!-- {{freightInvoice.amount.value}} -->
              </td>
            </tr>
          </tbody>
        </table>
        <table class="otherchargesTable" border="1" border-collapse="collapse" cellspacing="0" cellpadding="0">
          <tbody>
            <tr>
              <td colspan="1">{{'INVOICE_PREVIEW.slno' | translate}}</td>
              <td colspan="3" style="width: 108px;"><strong>{{'INVOICE_PREVIEW.additional_charges' | translate}}</strong></td>
              <td colspan="2" style="padding-right:8px;">
                {{'INVOICE_PREVIEW.comments' | translate}}
                <!-- {{freightInvoice.total_additional_charges}} -->
              </td>
              <td colspan="2" style="padding-right:8px;">
                <strong> {{ invoice_data.total_additional_charges}} </strong>
                <!-- {{freightInvoice.total_additional_charges}} -->
              </td>

            </tr>
            <!-- if (additionalCharges.length > 0) {
            for (var i = 0; i < additionalCharges.length; i++) { -->
            <tr>
              <td colspan="1">1.</td>
              <td colspan="3" class="paddingleft">
                <!-- additionalCharges[i].label -->
                {{'INVOICE_PREVIEW.porter' | translate}}
              </td>
              <td colspan="2" class="comments">
                {{ other_charges.labour_comment }}
                <!-- additionalCharges[i].value -->
              </td>
              <td colspan="1" class="otherValues">
                {{ other_charges.labour }}
                <!-- additionalCharges[i].value -->
              </td>
            </tr>
            <tr>
              <td colspan="1">2.</td>
              <td colspan="3" class="paddingleft">
                <!-- additionalCharges[i].label -->
                {{'INVOICE_PREVIEW.cancellation' | translate}}
              </td>
              <td colspan="2" class="comments">
                {{ other_charges.cancellation_comment }}
                <!-- additionalCharges[i].value -->
              </td>
              <td colspan="1" class="otherValues">
                {{ other_charges.cancellation }}
                <!-- additionalCharges[i].value -->
              </td>
              <!-- <td colspan="1" style="width:99px;"></td> -->
            </tr>
            <tr>
              <td colspan="1">3.</td>

              <td colspan="3" class="paddingleft">
                <!-- additionalCharges[i].label -->
                {{'INVOICE_PREVIEW.extra_pickup_point' | translate}}
              </td>
              <td colspan="2" class="comments">
                {{ other_charges.extra_pickup_comment }}
                <!-- additionalCharges[i].value -->
              </td>
              <td colspan="1" class="otherValues">
                {{ other_charges.extra_pickup }}
                <!-- additionalCharges[i].value -->
              </td>
              <!-- <td colspan="1" style="width:99px;"></td> -->
            </tr>
            <tr>
              <td colspan="1">4.</td>

              <td colspan="3" class="paddingleft">
                <!-- additionalCharges[i].label -->
                {{'INVOICE_PREVIEW.extra_delivery_point' | translate}}
              </td>
              <td colspan="2" class="comments">
                {{ other_charges.extra_delivery_comment }}
                <!-- additionalCharges[i].value -->
              </td>
              <td colspan="1" class="otherValues">
                {{ other_charges.extra_delivery }}
                <!-- additionalCharges[i].value -->
              </td>
              <!-- <td colspan="1" style="width:99px;"></td> -->
            </tr>
            <tr>
              <td colspan="1">5.</td>

              <td colspan="3" class="paddingleft">
                <!-- additionalCharges[i].label -->
                {{'INVOICE_PREVIEW.toll' | translate}}
              </td>
              <td colspan="2" class="comments">
                {{ other_charges.toll_comment }}
                <!-- additionalCharges[i].value -->
              </td>
              <td colspan="1" class="otherValues">
                {{ other_charges.toll }}
                <!-- additionalCharges[i].value -->
              </td>

              <!-- <td colspan="1" style="width:99px;"></td> -->
            </tr>
            <tr>
              <td colspan="1">6.</td>

              <td colspan="3" class="paddingleft">
                <!-- additionalCharges[i].label -->
                {{'INVOICE_PREVIEW.waybill' | translate}}
              </td>
              <td colspan="2" class="comments">
                {{ other_charges.LR_charges_comment}}
                <!-- additionalCharges[i].value -->
              </td>
              <td colspan="1" class="otherValues">
                {{ other_charges.LR_charges }}
                <!-- additionalCharges[i].value -->
              </td>
              <!-- <td colspan="1" style="width:99px;"></td> -->
            </tr>
            <tr>
              <td colspan="1">7.</td>

              <td colspan="3" class="paddingleft">
                <!-- additionalCharges[i].label -->
                {{'INVOICE_PREVIEW.insurance' | translate}}
              </td>
              <td colspan="2" class="comments">
                {{ other_charges.insurance_comment }}
                <!-- additionalCharges[i].value -->
              </td>
              <td colspan="1" class="otherValues">
                {{ other_charges.insurance }}
                <!-- additionalCharges[i].value -->
              </td>
              <!-- <td colspan="1" style="width:99px;"></td> -->
            </tr>
            <tr>
              <td colspan="1">8.</td>

              <td colspan="3" class="paddingleft">
                <!-- additionalCharges[i].label -->
                {{'INVOICE_PREVIEW.outStationHalt' | translate}}
              </td>
              <td colspan="2" class="comments">
                {{ other_charges.non_hometown_halt_comment }}
                <!-- additionalCharges[i].value -->
              </td>
              <td colspan="1" class="otherValues">
                {{ other_charges.non_hometown_halt }}
                <!-- additionalCharges[i].value -->
              </td>
              <!-- <td colspan="1" style="width:99px;"></td> -->
            </tr>
            <tr>
              <td colspan="1">9.</td>

              <td colspan="3" class="paddingleft">
                <!-- additionalCharges[i].label -->
                {{'INVOICE_PREVIEW.doc' | translate}}
              </td>
              <td colspan="2" class="comments">
                {{ other_charges.doc_comment }}
                <!-- additionalCharges[i].value -->
              </td>
              <td colspan="1" class="otherValues">
                {{ other_charges.doc }}
                <!-- additionalCharges[i].value -->
              </td>
              <!-- <td colspan="1" style="width:99px;"></td> -->
            </tr>
            <tr>
              <td colspan="1">10.</td>

              <td colspan="3" class="paddingleft">
                <!-- additionalCharges[i].label -->
                {{'INVOICE_PREVIEW.detentionCustomer' | translate}}
              </td>
              <td colspan="2" class="comments">
                {{ other_charges.detention_customer_comment }}
                <!-- additionalCharges[i].value -->
              </td>
              <td colspan="1" class="otherValues">
                {{ other_charges.detentionCustomer }}
                <!-- additionalCharges[i].value -->
              </td>
              <!-- <td colspan="1" style="width:99px;"></td> -->
            </tr>
            <tr>
              <td colspan="1">11.</td>

              <td colspan="3" class="paddingleft">
                <!-- additionalCharges[i].label -->
                {{'INVOICE_PREVIEW.detentionPlant' | translate}}
              </td>
              <td colspan="2" class="comments">
                {{ other_charges.detention_plant_comment }}
                <!-- additionalCharges[i].value -->
              </td>
              <td colspan="1" class="otherValues">
                {{ other_charges.detentionPlant }}
                <!-- additionalCharges[i].value -->
              </td>
              <!-- <td colspan="1" style="width:99px;"></td> -->
            </tr>
            <tr>
              <td colspan="1">12.</td>

              <td colspan="3" class="paddingleft">
                <!-- additionalCharges[i].label -->
                {{'INVOICE_PREVIEW.other_charges' | translate}}
              </td>
              <td colspan="2" class="comments">
                {{ other_charges.others_comment }}
                <!-- additionalCharges[i].value -->
              </td>
              <td colspan="1" class="otherValues">
                {{ other_charges.others }}
                <!-- additionalCharges[i].value -->
              </td>
              <!-- <td colspan="1" style="width:99px;"></td> -->
            </tr>
            <tr>
              <td colspan="1">13.</td>

              <td colspan="3" class="paddingleft">
                <!-- additionalCharges[i].label -->
                {{'INVOICE_PREVIEW.green_tax' | translate}}
              </td>
              <td colspan="2" class="comments">
                {{ other_charges.green_tax_comment }}
                <!-- additionalCharges[i].value -->
              </td>
              <td colspan="1" class="otherValues">
                {{ other_charges.green_tax }}
                <!-- additionalCharges[i].value -->
              </td>
              <!-- <td colspan="1" style="width:99px;"></td> -->
            </tr>
            <tr *ngIf="other_charges && other_charges.detention">
              <td colspan="1">14.</td>

              <td colspan="3" class="paddingleft">
                <!-- additionalCharges[i].label -->
                {{'INVOICE_PREVIEW.detention' | translate}}
              </td>
              <td colspan="2" class="comments">
                {{ other_charges.detention_comment }}
                <!-- additionalCharges[i].value -->
              </td>
              <td colspan="1" class="otherValues">
                {{ other_charges.detention}}
                <!-- additionalCharges[i].value -->
              </td>
              <!-- <td colspan="1" style="width:99px;"></td> -->
            </tr>
          </tbody>
        </table>
        <table class="otherchargesTable" border="1" border-collapse="collapse" cellspacing="0" cellpadding="0" *ngIf="showDeductibleCharges" >
          <tbody>
            <tr>
              <td colspan="1">{{'INVOICE_PREVIEW.slno' | translate}}</td>
              <td colspan="3"><strong>{{'INVOICE_PREVIEW.deductible_charges' | translate}}</strong></td>
              <td colspan="2" style="padding-right:8px; width: 70px;">
                {{'INVOICE_PREVIEW.comments' | translate}}
                <!-- {{freightInvoice.total_additional_charges}} -->
              </td>
              <td colspan="2" style="padding-right:8px;">
                <strong> {{ invoice_data.total_deductible_charges}} </strong>
                <!-- {{freightInvoice.total_additional_charges}} -->
              </td>

            </tr>
            <!-- if (additionalCharges.length > 0) {
            for (var i = 0; i < additionalCharges.length; i++) { -->
            <tr>
              <td colspan="1">1.</td>
              <td colspan="3" class="paddingleft">
                <!-- additionalCharges[i].label -->
                {{'INVOICE_PREVIEW.material_damage' | translate}}
              </td>
              <td colspan="2" class="comments">
                {{ deductible_charges.material_damage_comment }}
                <!-- additionalCharges[i].value -->
              </td>
              <td colspan="1" class="otherValues">
                {{ deductible_charges.material_damage }}
                <!-- additionalCharges[i].value -->
              </td>
            </tr>
            <tr>
              <td colspan="1">2.</td>

              <td colspan="3" class="paddingleft">
                <!-- additionalCharges[i].label -->
                {{'INVOICE_PREVIEW.material_missing' | translate}}
              </td>
              <td colspan="2" class="comments">
                {{ deductible_charges.material_missing_comment }}
                <!-- additionalCharges[i].value -->
              </td>
              <td colspan="1" class="otherValues">
                {{ deductible_charges.material_missing }}
                <!-- additionalCharges[i].value -->
              </td>
              <!-- <td colspan="1" style="width:99px;"></td> -->
            </tr>
            <tr>
              <td colspan="1">3.</td>

              <td colspan="3" class="paddingleft">
                <!-- additionalCharges[i].label -->
                {{'INVOICE_PREVIEW.vehicle_delay' | translate}}
              </td>
              <td colspan="2" class="comments">
                {{ deductible_charges.vehicle_delay_comment }}
                <!-- additionalCharges[i].value -->
              </td>
              <td colspan="1" class="otherValues">
                {{ deductible_charges.vehicle_delay }}
                <!-- additionalCharges[i].value -->
              </td>
              <!-- <td colspan="1" style="width:99px;"></td> -->
            </tr>
            <tr>
              <td colspan="1">4.</td>

              <td colspan="3" class="paddingleft">
                <!-- additionalCharges[i].label -->
                {{'INVOICE_PREVIEW.carton_damage' | translate}}
              </td>
              <td colspan="2" class="comments">
                {{ deductible_charges.carton_damage_comment }}
                <!-- additionalCharges[i].value -->
              </td>
              <td colspan="1" class="otherValues">
                {{ deductible_charges.carton_damage }}
                <!-- additionalCharges[i].value -->
              </td>
              <!-- <td colspan="1" style="width:99px;"></td> -->
            </tr>
            <tr>
              <td colspan="1">5.</td>

              <td colspan="3" class="paddingleft">
                <!-- additionalCharges[i].label -->
                {{'INVOICE_PREVIEW.others' | translate}}
              </td>
              <td colspan="2" class="comments">
                {{ deductible_charges.others_comment }}
                <!-- additionalCharges[i].value -->
              </td>
              <td colspan="1" class="otherValues">
                {{ deductible_charges.others }}
                <!-- additionalCharges[i].value -->
              </td>
              <!-- <td colspan="1" style="width:99px;"></td> -->
            </tr>
          </tbody>
        </table>
      </div>
      <table class="commonDetails" border="1" cellspacing="0" cellpadding="0">
        <tr>
          <td><strong>  {{'INVOICE_PREVIEW.desc_goods' | translate}}:</strong>&nbsp;
            <span>
              <!--  *ngFor="let item of shipment.materials" -->
              <!-- {{item.name}}, -->
              {{ invoice_data.materials }}
            </span>
          </td>
        </tr>
      </table>
      <table border="1" cellspacing="0" cellpadding="0" class="commonTable">
        <tbody>
          <tr>
            <td rowspan="2" class="leftDiv"><strong>{{'INVOICE_PREVIEW.remarks' | translate}}:</strong></td>

            <td class="centerDiv"><strong>{{'INVOICE_PREVIEW.sub_total' | translate}}</strong></td>
            <td class="rightDiv">
              <strong> {{currencySymbol}}
                <!-- {{shipment.country.currency.symbol}} -->
                {{ invoice_data.sub_total }}
                <!-- {{parseFloat(freightInvoice.amount.value +freightInvoice.total_additional_charges).toFixed(2)}} -->
              </strong>
            </td>
          </tr>
          <tr>
            <td class="centerDiv"><span class="red">{{'INVOICE_PREVIEW.discount' | translate}}</span></td>
            <td class="rightDiv">
              <span class="red">
                {{ currencySymbol }}
                <!-- {{shipment.country.currency.symbol}} -->
                {{ invoice_data.discount.amount.toFixed(2) }}
                <!-- {{(freightInvoice.discount) ? freightInvoice.discount.amount : 0}} -->
              </span>
            </td>
          </tr>
          <tr class="bg-grey">
            <td [attr.rowspan]="span" class="leftDiv"><strong>{{'INVOICE_PREVIEW.final_amount_words' | translate}}:</strong><br><span
                style="text-transform: capitalize;"><strong>
                  <!-- {{shipment.country.currency.name}} -->{{ currencySymbol }}
                </strong> {{ invoice_data.final_amount_words }} </span>
            </td>
            <td class="centerDiv"><strong>{{'INVOICE_PREVIEW.pre_tax' | translate}}</strong></td>
            <td class="rightDiv">
              <strong>
                <!-- {{shipment.country.currency.symbol}}  --> {{ currencySymbol }}
                <!-- {{freightInvoice.totalBeforeTax}} --> {{ invoice_data.pre_tax_amount }}
              </strong></td>
          </tr>
          <tr *ngIf="(country == 'SA' || country == 'BR') && !invoice_data.URD && !invoice_data.GTAtoGTA">
            <td class="centerDiv" >
              {{'INVOICE_PREVIEW.gst' | translate}} ({{gst}}%)
            </td>
            <td class="rightDiv">
              <!-- {{shipment.country.currency.symbol}} -->{{ currencySymbol }}
              <!-- {{freightInvoice.tax}} -->{{ invoice_data.tax_amount }}
            </td>
          </tr>
          <tr *ngIf="invoice_data.tax_type == 'FCM12' && invoice_data.transit_type == 'INTRA' && country == 'IN' && !invoice_data.URD && !invoice_data.GTAtoGTA ">
            <td class="centerDiv" >
              {{'INVOICE_PREVIEW.sgst' | translate}} ({{gst / 2}}%) + {{'INVOICE_PREVIEW.cgst' | translate}} ({{gst / 2}}%)
            </td>
            <td class="rightDiv">
              <!-- {{shipment.country.currency.symbol}} -->{{ currencySymbol }}
              <!-- {{freightInvoice.tax}} -->{{ invoice_data.tax_amount }}
            </td>
          </tr>
          <tr *ngIf="invoice_data.tax_type == 'FCM12' && invoice_data.transit_type == 'INTER' && country == 'IN' && !invoice_data.URD && !invoice_data.GTAtoGTA">
            <td class="centerDiv" >
              {{'INVOICE_PREVIEW.igst' | translate}} ({{gst}}%)
            </td>
            <td class="rightDiv">
              <!-- {{shipment.country.currency.symbol}} -->{{ currencySymbol }}
              <!-- {{freightInvoice.tax}} -->{{ invoice_data.tax_amount }}
            </td>
          </tr>

          <tr *ngIf="invoice_data.tax_type == 'FCM18' && invoice_data.transit_type == 'INTRA' && country == 'IN' && !invoice_data.URD && !invoice_data.GTAtoGTA ">
            <td class="centerDiv" >
              {{'INVOICE_PREVIEW.sgst' | translate}} ({{gst / 2}}%) + {{'INVOICE_PREVIEW.cgst' | translate}} ({{gst / 2}}%)
            </td>
            <td class="rightDiv">
              <!-- {{shipment.country.currency.symbol}} -->{{ currencySymbol }}
              <!-- {{freightInvoice.tax}} -->{{ invoice_data.tax_amount }}
            </td>
          </tr>
          <tr *ngIf="invoice_data.tax_type == 'FCM18' && invoice_data.transit_type == 'INTER' && country == 'IN' && !invoice_data.URD && !invoice_data.GTAtoGTA">
            <td class="centerDiv" >
              {{'INVOICE_PREVIEW.igst' | translate}} ({{gst}}%)
            </td>
            <td class="rightDiv">
              <!-- {{shipment.country.currency.symbol}} -->{{ currencySymbol }}
              <!-- {{freightInvoice.tax}} -->{{ invoice_data.tax_amount }}
            </td>
          </tr>

          <tr *ngIf="invoice_data.tax_type == 'RCM' && invoice_data.transit_type == 'INTRA' && country == 'IN' && !invoice_data.URD && !invoice_data.GTAtoGTA">
            <td class="centerDiv" >
              {{'INVOICE_PREVIEW.sgst' | translate}} ({{gst / 2}}%) + {{'INVOICE_PREVIEW.cgst' | translate}} ({{gst / 2}}%)
            </td>
            <td class="rightDiv">
              <!-- {{shipment.country.currency.symbol}} -->{{ currencySymbol }}
              <!-- {{freightInvoice.tax}} -->{{ invoice_data.tax_amount }}
            </td>
          </tr>

          <tr *ngIf="invoice_data.tax_type == 'RCM' && invoice_data.transit_type == 'INTRA' && country == 'IN' && !invoice_data.URD && !invoice_data.GTAtoGTA">
            <td class="centerDiv" >
              {{'INVOICE_PREVIEW.gst_reversible' | translate}} ({{gst}}%)
            </td>
            <td class="rightDiv">
              <!-- {{shipment.country.currency.symbol}} -->{{ currencySymbol }}
              <!-- {{freightInvoice.tax}} -->{{ invoice_data.tax_amount }}
            </td>
          </tr>

          <tr *ngIf="invoice_data.tax_type == 'RCM' && invoice_data.transit_type == 'INTER' && country == 'IN' && !invoice_data.URD && !invoice_data.GTAtoGTA ">
            <td class="centerDiv" >
              {{'INVOICE_PREVIEW.igst' | translate}} ({{gst}}%)
            </td>
            <td class="rightDiv">
              <!-- {{shipment.country.currency.symbol}} -->{{ currencySymbol }}
              <!-- {{freightInvoice.tax}} -->{{ invoice_data.tax_amount }}
            </td>
          </tr>

          <tr *ngIf="invoice_data.tax_type == 'RCM' && invoice_data.transit_type == 'INTER' && country == 'IN' && !invoice_data.URD && !invoice_data.GTAtoGTA">
            <td class="centerDiv" >
              {{'INVOICE_PREVIEW.gst_reversible' | translate}} ({{gst}}%)
            </td>
            <td class="rightDiv">
              <!-- {{shipment.country.currency.symbol}} -->{{ currencySymbol }}
              <!-- {{freightInvoice.tax}} -->{{ invoice_data.tax_amount }}
            </td>
          </tr>
          <tr>
            <td class="centerDiv"><strong>{{'INVOICE_PREVIEW.total_amount' | translate}}</strong></td>
            <td class="rightDiv">
              <strong>
                <!-- {{shipment.country.currency.symbol}}  --> {{ currencySymbol }}
                <!-- {{freightInvoice.final_amount}} --> {{ invoice_data.final_amount }}
              </strong>
            </td>
          </tr>
          <tr>
            <td class="centerDiv"><strong>{{'INVOICE_PREVIEW.advance' | translate}}</strong></td>
            <td class="rightDiv">
              <strong> {{currencySymbol}}
                <!-- {{shipment.country.currency.symbol}} -->
                {{ invoice_data.advance_amount }}
                <!-- {{parseFloat(freightInvoice.amount.value +freightInvoice.total_additional_charges).toFixed(2)}} -->
              </strong>
            </td>
          </tr>
          <tr>
            <td class="centerDiv"><strong>{{'INVOICE_PREVIEW.net_payable_amount' | translate}}</strong></td>
            <td class="rightDiv">
              <strong> {{currencySymbol}}
                <!-- {{shipment.country.currency.symbol}} -->
                {{ invoice_data.net_payable_amount }}
                <!-- {{parseFloat(freightInvoice.amount.value +freightInvoice.total_additional_charges).toFixed(2)}} -->
              </strong>
            </td>
          </tr>
          <!-- </tr> -->
          <tr>
            <td rowspan="2" colspan="1" class="leftDiv"><strong>{{'INVOICE_PREVIEW.terms_conditions' | translate}}:</strong><br>
              <p style="font-size:8px">{{ terms_conditions }} </p>
            </td>
            <td class="certificate" rowspan="2" colspan="2">{{'INVOICE_PREVIEW.cert_text' | translate}}
              <p style="font-size:10px"><strong>{{'INVOICE_PREVIEW.for' | translate}}
                  <!-- shipment.carrier.parent_name  -->
                  {{ invoice_data.carrier_info.enterprise }}
                </strong></p>
              <p style="padding-top:35px;"> {{'INVOICE_PREVIEW.autherised_signatory' | translate}}</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="annexure">
      <div class="title">
        {{'INVOICE_PREVIEW.annexure' | translate}}
      </div>
      <div class="remarks">
        <div class="label">
          {{'INVOICE_PREVIEW.remarks' | translate}}
        </div>
        <div class="invoice-section">
          <div class="invoice" *ngFor="let invoice of invoice_data.annexure.invoices;let i=index">
            {{i+1}}. <strong>{{invoice.num}}</strong> - | {{'INVOICE_PREVIEW.status' | translate}}: | {{'INVOICE_PREVIEW.missing' | translate}} : {{invoice.missing.nop}} ({{invoice.missing.value}}) | {{'INVOICE_PREVIEW.damaged' | translate}} : {{invoice.damaged.nop}} ({{invoice.damaged.value}}) |  {{'INVOICE_PREVIEW.rejected' | translate}} : {{invoice.rejected.nop}} ({{invoice.rejected.value}})
          </div>
        </div>
      </div>
      <div class="remarks">
        <div class="label">
          {{'INVOICE_PREVIEW.documents' | translate}}
        </div>
        <div class="image-section">
          <span class="image-container" *ngFor="let doc of invoice_data.annexure.docs">
            <img src="{{doc}}" alt="" height="200" width="200">
          </span>
        </div>
      </div>
    </div>
  </div>

</div>


